export default __webpack_public_path__ + "static/media/Shape.01a9d363.png";